export const styles = {
  expandedCell: {
    whiteSpace: "pre-wrap" as const,
    fontFamily: "monospace",
  },
  tableCenter: {
    width: "100%",
    maxWidth: "100%",
    display: "block",
    boxSizing: "border-box" as const,
  },
};


export const runsTableColumnWidths: number[] = [
  20,  // Index
  300, // Generation Time
  30,  // Status
  80,  // Task Type
  80,  // User
  200, // Email
];
